import { useEffect } from "react";

/**
 * Custom hook to provide fixed curved button/table/card styles
 * @returns {Object} Object with buttonClass and tableClass
 */
export const useButtonTableStyle = () => {
  useEffect(() => {
    localStorage.setItem("buttonTableStyle", "curve");
  }, []);

  const buttonTableStyle = "curve";
  const buttonClass = "rounded-1";
  const tableClass = "table-rounded";
  const cardClass = "rounded-3";

  return {
    buttonClass,
    tableClass,
    cardClass,
    buttonTableStyle,
  };
};
